module.exports = __webpack_public_path__ + "static/media/order_default.0bbcc5d6.svg";